/* eslint-disable jsx-a11y/media-has-caption */
import React, { useEffect, useRef } from 'react';

import ringSrc from '../../../../assets/audio/ring2.mp3';
import { subscribeToNotification } from '../../../../redux/opentok/helpers/notifications';

function AudioTag() {
  const audioRef = useRef();
  useEffect(() => subscribeToNotification(playAudio), []);

  function playAudio() {
    audioRef.current.play();
  }

  return (
    <audio ref={audioRef}>
      <source src={ringSrc} />
      Your browser isn't invited for super fun audio time.
    </audio>
  );
}

AudioTag.propTypes = {};

export default AudioTag;



// WEBPACK FOOTER //
// ./src/components/VirtualVideoRoom/Components/AudioTag/index.jsx